
  jQuery(document).ready(function(){
    var ur = window.location.href;
if(ur.includes('/product') && jQuery('.nutra-atc').length == 0){
  
  var pricing = jQuery('.bo_onetime_price');
  for(var i  =0; i < pricing.length; i++){
    pricing.eq(i).before(jQuery('<div class="nutra-pricing"></div>'));
     jQuery('.nutra-pricing').eq(i).append(jQuery('.bo_onetime_price .bo_save').eq(0));
     jQuery('.nutra-pricing').eq(i).prepend(pricing.eq(i));
    
  }
  
  var pricing = jQuery('.bo_subscribe_price');
  for(var i  =0; i < pricing.length; i++){
    pricing.eq(i).before(jQuery('<div class="nutra-pricing sub"></div>'));
   
    jQuery('.nutra-pricing.sub').eq(i).append(jQuery('.bo_subscribe_price .bo_save').eq(0));
     jQuery('.nutra-pricing.sub').eq(i).prepend(pricing.eq(i));
    
  }
var save = jQuery('span.bo_save');
    for(var i = 0; i < save.length; i++){
      if(!save.eq(i).html().includes('Save')){
        if(window.innerWidth < 768){
          save.eq(i).addClass('mb-20');
          save.eq(i).parent().addClass('mt-20')
        }
       // 
      }
    }
}
  });
 
 
var ur = window.location.href;
if(ur.includes('/product') && jQuery('.nutra-atc').length == 0){
  jQuery(document).ready(function(){
  jQuery('.bottle_main').eq(0).after(jQuery('<div class="nutra-atc">Add TO Cart</div>'))
  
  jQuery('.nutra-atc').click(function(){
  jQuery('.bottle_item.active button.action_button.add_to_cart').eq(0).click();
	}); 
    
    jQuery('div#rc_radio_options label').click(function(){
      if(jQuery(this).hasClass('rc_label__autodeliver')) {
        jQuery('.nutra-atc').html('Subscribe & Save');
      }
       else{
          jQuery('.nutra-atc').html('Add TO Cart')
       }
	}); 
    
  var af = 0; var timeraf = setInterval(function(){
  if(jQuery('afterpay-placement').length) {
	jQuery('.bottle_main').eq(0).after(jQuery('.nutra-atc').eq(0));
clearInterval(timeraf);}if( af > 200){clearInterval(timeraf);}af++;}, 50);
});
}




  
    var ur = window.location.href;
if(ur.includes('/product') ){
  
jQuery(document).ready(function(){
  
      var sss = 0; var timersss = setInterval(function(){
  if( jQuery('.bottle_item.bottle2').length) {
	 jQuery('.bottle_item.bottle2').eq(0).click();
clearInterval(timersss);}if( sss > 200){clearInterval(timersss);}sss++;}, 50);
//jQuery('.product_form').eq(0).after(jQuery('.product_sentence').eq(0));
var ur = window.location.href;
Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var ctaCopy = "ADD TO CART";
  var lnk = '#';
  var stickyCopy = jQuery('h1.product_name').eq(0).text();
  
var sticky = document.createElement('div');
sticky.innerHTML='<div class="nutra-st-container" id="nutra-st-containerID"> <div class="nutra-st-container__outer"> <div class="nutra-st-container__inner"> <div class="nutra-cont"> <div class="nutra-st-copy"> <p>'+stickyCopy+'</p><span class="sticky-price">•<span></span></span> </div><div class="nutra-st-meta"><span class="nutra-st-bottles"></span>•<span class="nutra-st-delivery"></span><span class="nutra-st-edit-order">Edit Order</span></div></div><div class="nutra-st-usp-container"> <div class="nutra-st-usp1"><img class="nutra-st-usp-icon" src="https://cdn.shopify.com/s/files/1/0283/9478/2817/files/image_3shipping.png?v=1660331961"><div class="nutra-st-usp-copy">FREE SHIPPING ON U.S. ORDERS OVER $49</div></div><div class="nutra-st-usp2"><img class="nutra-st-usp-icon" src="https://cdn.shopify.com/s/files/1/0283/9478/2817/files/image_4money_back.png?v=1660331961"><div class="nutra-st-usp-copy">100% MONEY BACK GUARANTEE</div></div></div><div class="nutra-st-item_column__button"><a class="nutra-st-item__button">'+ctaCopy+'</a></div></div></div></div></div>';
var y = document.getElementsByTagName('body');
if (document.getElementsByClassName('nutra-st-container').length == 0) {
    y[0].appendChild(sticky);
  console.log('here');
  
   jQuery('.nutra-st-edit-order').click(function(){
    
    $('html, body').animate({
        scrollTop: $('.product_form').offset().top - 60
    }, 500);
}); 
  
}
$('.nutra-st-item__button').click(function(){
  $(this).text('Adding...');
   setTimeout(function(){ 
$('.nutra-st-item__button').text('ADD TO CART');
}, 2000);
  $('.nutra-atc').eq(0).click();
}); 
  
   setInterval(function(){ 
	
     if(jQuery('.rc_block.rc_block__type.rc_block__type--active').hasClass('rc_block__type__onetime')){
       jQuery("span.nutra-st-delivery").html(jQuery('.rc_block.rc_block__type.rc_block__type--active label').html() );
       jQuery("span.nutra-st-bottles").html(jQuery('.bottle_item.active h4').html());
        jQuery('.sticky-price span').eq(0).html(jQuery('.bottle_item.active .bo_onetime_price span.bo_regular_price').eq(0).html());
     jQuery('.sticky-price span').eq(0).append(jQuery(' .bottle_item.active .bo_onetime_price span.bo_compare_price').eq(0).clone());
     }
     else{
       jQuery("span.nutra-st-delivery").html(jQuery('.drop_selected').text().replace(':', '') + "s");
       jQuery("span.nutra-st-bottles").html(jQuery('.bottle_item.active .nutra-pricing.sub h4').html());
        jQuery('.sticky-price span').eq(0).html(jQuery('.bottle_item.active .nutra-pricing.sub span.bo_regular_price').eq(0).html());
     jQuery('.sticky-price span').eq(0).append(jQuery(' .bottle_item.active .nutra-pricing.sub  span.bo_compare_price').eq(0).clone());
     }
    
     
}, 1000);
  
 
var mc = window.matchMedia("(min-width: 767px)");
var elem = document.getElementById("nutra-st-containerID");
function slideShow() {
    jQuery('body').addClass('nutra-sticky');
}
function slideHide() {
   jQuery('body').removeClass('nutra-sticky');
}
  
jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery('.nutra-atc').eq(0).offset().top) {
        slideShow();
    } else {
        slideHide();
    }
}); 
  }); 
}
